module.exports = __webpack_public_path__ + "img/karinfehr.dcafc169.svg";